/** Auto-dismiss delay for app toasts (ms). `0` keeps a toast until `dismiss`. */
export const TOAST_DURATION = 4000

/** Delay before closing the popover host after the last toast leaves (ms). */
export const TOAST_HIDE_DELAY_MS = 280

export const TOAST_TYPE = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
})

export const TOAST_TYPES = Object.freeze(Object.values(TOAST_TYPE))
